import { render, staticRenderFns } from "./fansLabel.vue?vue&type=template&id=e8bdd4fe&scoped=true&"
import script from "./fansLabel.vue?vue&type=script&lang=js&"
export * from "./fansLabel.vue?vue&type=script&lang=js&"
import style0 from "./fansLabel.vue?vue&type=style&index=0&id=e8bdd4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bdd4fe",
  null
  
)

export default component.exports